module.exports = __webpack_public_path__ + "static/img/sequence-smoke.e7d715a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/sequence-smoke.png
// module id = 677
// module chunks = 64